export default {
  "viewDocument": "Visualizza",
  "unableToLoadBudgets": "Incapace di caricare i budget.",
  "budgetUpdated": "Bilancio aggiornato",
  "theBudgetDetailsHaveBeenSaved": "I dettagli del bilancio sono stati salvati.",
  "unableToUpdateBudget": "Incapace di aggiornare il budget",
  "pleaseTryAgainInAMoment": "Si prega di riprovare in un momento.",
  "budgetDeleted": "Bilancio cancellato",
  "theBudgetHasBeenRemoved": "Il bilancio è stato rimosso.",
  "budgetCannotBeDeleted": "Il bilancio non può essere cancellato",
  "unableToDeleteBudget": "Incapace di eliminare il budget",
  "onlyDraftBudgetsWithoutLockedVersionsCanBeDeleted": "Solo i progetti di bilancio senza versioni bloccate possono essere eliminati.",
  "unableToCreateBudget": "Incapace di creare budget.",
  "newBudget": "Nuovo bilancio",
  "createANewBudget": "Creare un nuovo budget",
  "name": "Nome",
  "fy2025OperatingBudget": "FY 2025 Bilancio operativo",
  "fiscalYearStart": "Inizio anno fiscale",
  "fiscalYearEnd": "Fine anno fiscale",
  "copyFromBudgetOptional": "Copia dal budget (opzionale)",
  "selectBudget": "Seleziona budget",
  "noCopy": "Nessuna copia",
  "copyFromVersionOptional": "Copia dalla versione (opzionale)",
  "selectVersion": "Selezionare la versione",
  "currentVersion": "Versione attuale",
  "cancel": "Annulla",
  "createBudget": "Creare un bilancio",
  "budgetingError": "Errore di bilancio",
  "loadingBudgets": "Caricamento di budget...",
  "editBudget": "Modifica del bilancio",
  "saveChanges": "Salva le modifiche",
  "deleteBudget": "Eliminare il budget",
  "delete": "Elimina",
  "noBudgetsYetClickNewBudgetToCreateYourFirstBudget": "Non ci sono ancora budget. Fare clic su “Nuovi budget” per creare il tuo primo budget.",
  "fiscalYear": "Anno fiscale",
  "status": "Stato",
  "updated": "Aggiornato",
  "open": "Apri",
  "openBudgetActions": "Azioni di bilancio aperte",
  "edit": "Modifica",
  "jan": "Jan.",
  "feb": "Febbraio",
  "mar": "Mar Mediterraneo",
  "apr": "A.",
  "may": "Maggio",
  "jun": "Jun",
  "jul": "Luglio",
  "aug": "Agosto",
  "sep": "Segreto",
  "oct": "Ottobre",
  "nov": "No.",
  "dec": "Dec.",
  "q1": "Q1",
  "q2": "Q2",
  "q3": "Q3",
  "q4": "Q4",
  "draft": "Bozza",
  "submitted": "Inviato",
  "boardApproved": "Approvazione da parte del Consiglio",
  "locked": "Bloccato",
  "rejected": "Rifiuti",
  "originalBudget": "Bilancio originale",
  "reforecast": "Rivedi la previsione",
  "boardMandated": "Mandato del Consiglio",
  "other": "Altro",
  "operating": "Funzionamento operativo",
  "capex": "Caps.",
  "fyDatesNotSet": "FY date non impostate",
  "allDepartments": "Tutti i dipartimenti",
  "selectGlAccount": "Selezionare account GL",
  "searchGlAccounts": "Cerca i conti GL...",
  "noGlAccountsFound": "Nessun account GL trovato.",
  "selectDepartment": "Seleziona il reparto",
  "searchDepartments": "Dipartimenti di ricerca...",
  "noDepartmentsFound": "Nessun dipartimento trovato.",
  "unableToLoadBudgetDetails": "Incapace di caricare i dettagli del budget.",
  "unableToLoadReferenceData": "Non è possibile caricare i dati di riferimento.",
  "unableToLoadBudgetLines": "Incapace di caricare le linee di bilancio.",
  "couldntLoadYourAutosavePreference": "Non ho potuto caricare la tua preferenza auto-salvata",
  "autosaveIsOffByDefaultUntilWeCanLoadYourSetting": "Auto-save è disattivata per impostazione predefinita fino a quando non possiamo caricare la vostra impostazione.",
  "allCategories": "Tutti i gruppi",
  "lineAlreadyExists": "Linea già esistente",
  "aBudgetLineWithTheseDetailsAlreadyExists": "Una linea di bilancio con questi dettagli esiste già.",
  "unableToPrepareAttachments": "Incapace di preparare gli allegati",
  "pleaseTryAgain": "Riprova.",
  "lineDetailsChanged": "Dettagli della linea cambiate",
  "attachmentsWereClearedPleaseReuploadAnyDocuments": "Gli allegati sono stati cancellati, si prega di ri-caricare qualsiasi documento.",
  "unableToDiscardDraftLine": "Incapace di scartare la linea di bozza",
  "autosaved": "Salvato automaticamente",
  "changesSavedAutomatically": "Modifiche salvate automaticamente.",
  "budgetSaved": "Bilancio risparmiato",
  "changesHaveBeenSaved": "Sono state salvate delle modifiche.",
  "unableToSaveBudgetLines": "Incapace di salvare le linee di bilancio.",
  "autosaveFailed": "Autosalvataggio fallito",
  "autosaveFailedPleaseClickSaveChanges": "Risparmio automatico fallito, fare clic su Salva modifiche.",
  "readonlyVersion": "Versione sola lettura",
  "readonlyVersionCantBeAutosaved": "La versione di sola lettura non può essere auto-saved.",
  "unableToUpdateAutosave": "In grado di aggiornare l'auto-save",
  "unableToDeleteLine": "Non è possibile eliminare la linea.",
  "newVersionCreated": "Nuova versione creata",
  "aNewDraftVersionIsReadyForEditing": "Una nuova versione del progetto è pronta per la modifica.",
  "unableToCreateNewVersion": "Incapace di creare una nuova versione.",
  "versionDetailsUpdated": "Dettagli della versione aggiornata",
  "versionMetadataSavedSuccessfully": "I metadati di versione salvati con successo.",
  "unableToUpdateVersion": "Non è possibile aggiornare la versione",
  "pleaseTryAgainOrRefreshThePage": "Si prega di riprovare o aggiornare la pagina.",
  "unableToUpdateCurrentVersion": "Non è possibile aggiornare la versione corrente.",
  "submittedToTheGmForReleaseVotingWillOpenOnceApproved": "Inviato al GM per il rilascio — il voto si aprirà una volta approvato.",
  "votingAlreadyOpen": "Votazione già aperta",
  "votingIsAlreadyOpenForThisBudgetRefreshingTheMotionStatus": "La votazione è già aperta a questo bilancio. Raffreddare lo stato di movimento.",
  "alreadySubmitted": "Già presentato",
  "thisBudgetIsAlreadyQueuedForGmRelease": "Questo budget è già in coda per il rilascio GM.",
  "votingAlreadyClosed": "Votazione già chiusa",
  "thisBudgetMotionHasAlreadyBeenClosed": "Questa proposta di bilancio è già stata chiusa.",
  "submissionFailed": "Inadempimento di uno Stato",
  "unableToSubmitThisBudgetForBoardApproval": "Incapace di presentare questo bilancio per l'approvazione del Consiglio.",
  "withdrawSubmissionThisWillRevertToDraftAndRemoveItFromTheBoardQueue": "Ritirare la presentazione? Questo ritornerà a Draft e rimuoverlo dalla coda della scheda.",
  "submissionWithdrawnBudgetIsBackInDraft": "Ritiro della sottomissione — il bilancio è di nuovo nel progetto.",
  "thisSubmissionCanOnlyBeWithdrawnBeforeVotingOpens": "Questa sottomissione può essere ritirata solo prima dell'apertura del voto.",
  "votesAlreadyExistForThisMotion": "I voti esistono già per questa mozione.",
  "thisBudgetVersionIsNotCurrentlySubmitted": "Questa versione di bilancio non è attualmente presentata.",
  "noPendingMotionWasFoundForThisSubmission": "Non è stata trovata alcuna mozione in sospeso per questa presentazione.",
  "unableToWithdrawSubmission": "Incapace di ritirare la presentazione",
  "unableToDeleteBudgetEnsureItIsInDraftAndNoVersionsAreLocked": "Non è in grado di eliminare il budget. Assicurarsi che sia in bozza e nessuna versione è bloccata.",
  "statusUpdated": "Stato aggiornato",
  "unableToUpdateStatus": "Non è possibile aggiornare lo stato",
  "thisReopensAnApprovedBudgetAndAllowsEditsContinue": "Questo riapre un bilancio approvato e consente modifiche.",
  "lockedBudgetsCannotBeEditedAgainContinue": "I budget bloccati non possono essere modificati di nuovo.",
  "loadingBudgetDetails": "Caricamento dettagli budget...",
  "backToBudgeting": "Torna a Budgeting",
  "budgetNotFound": "Budget non trovato",
  "theSelectedBudgetCouldNotBeFoundForThisClub": "Il budget selezionato non è stato trovato per questo club.",
  "backToBudgets": "Torna a Budgets",
  "newVersion": "Nuova versione",
  "createANewVersion": "Creare una nuova versione",
  "createFromCurrentVersion": "Creare dalla versione attuale?",
  "copyFromSelectedVersion": "Copia dalla versione selezionata",
  "blankVersionNoLines": "Versione in bianco (senza linee)",
  "label": "Etichetta",
  "purpose": "Oggetto",
  "notes": "Note",
  "optionalNotesForThisVersion": "Note opzionali per questa versione",
  "createVersion": "Creare la versione",
  "setAsCurrent": "Impostare come corrente",
  "viewInBoardPortal": "Visualizza in Board Portal",
  "submitForBoardApproval": "Inviare per Approvazione del Consiglio",
  "withdrawSubmission": "Ritiro la presentazione",
  "budgetSettings": "Impostazioni di bilancio",
  "disableAutosave": "Disattivare il Risparmio Auto",
  "activateAutosave": "Attiva Auto-Save",
  "confirmStatusChange": "Confermare il cambiamento di stato",
  "confirm": "Conferma",
  "department": "Dipartimento",
  "category": "Categoria",
  "searchGl": "Ricerca GL",
  "searchByGlAccount": "Ricerca per conto GL",
  "view": "Visualizza",
  "monthly": "Mensile",
  "quarterly": "Trimestrale",
  "quarterlyViewEnabledForSmallerScreens": "Vista trimestrale abilitata per schermi più piccoli.",
  "addLine": "Aggiungere la linea",
  "editBudgetLine": "Modifica la voce di budget",
  "addBudgetLine": "Aggiungere la linea di bilancio",
  "glAccount": "Conto di contabilità generale",
  "ownerOptional": "Proprietario (opzionale)",
  "searchStaffByNameOrEmail": "Ricerca personale per nome o e-mail",
  "unassigned": "Non assegnato",
  "noMatches": "Nessuna corrispondenza",
  "typeAtLeast2CharactersToSearch": "Digita almeno 2 caratteri per cercare.",
  "searchingStaff": "Personale di ricerca...",
  "selectAStaffMemberToAssignOwnership": "Selezionare un membro del personale per assegnare la proprietà.",
  "uploadSupportingDocumentsForThisBudgetLine": "Carica documenti di supporto per questa linea di bilancio.",
  "deleteThisBudgetLine": "Eliminare questa linea di bilancio?",
  "thisWillRemoveTheLineFromTheVersionYouCanReaddItLaterIfNeeded": "Questo rimuoverà la linea dalla versione. È possibile ri-aggiungerla più tardi, se necessario.",
  "versionDetails": "Dettagli della versione",
  "created": "Creato",
  "saveDetails": "Salvare i dettagli",
  "saving": "Salvataggio…",
  "thisVersionIsNotInDraftAndCannotBeEditedCreateANewVersionToContinueEditing": "Questa versione non è in bozza e non può essere modificata. Crea una nuova versione per continuare la modifica.",
  "somethingWentWrong": "Qualcosa non va.",
  "total": "Totale",
  "noBudgetLinesYetUseAddLineToStartBuildingYourBudget": "Non ci sono ancora linee di bilancio. Utilizzare “Add Line” per iniziare a costruire il tuo budget.",
  "lineActions": "Azioni di linea",
  "editLine": "Modifica della linea",
  "documents": "Documenti…",
  "deleteLine": "Eliminare la linea",
  "supportingDocuments": "Documenti di supporto",
  "selectAGlAccountAndDepartmentToEnableDocumentUploads": "Selezionare un account e un reparto GL per abilitare gli upload dei documenti.",
  "unableToLoadDocuments": "Incapace di caricare documenti",
  "uploadFailed": "Caricamento in corso",
  "deleteFailed": "Eliminare il mancato",
  "downloadFailed": "Download non riuscito",
  "previewFailed": "Anteprima fallita",
  "dragDropFilesHere": "Trascinare e rilasciare i file qui",
  "pdfImagesWordDocsMax25mbEach": "PDF , immagini, documenti di Word • max 25MB ciascuno",
  "hangTightWhileWePrepUploads": "Tieni duro mentre prepariamo i caricamenti.",
  "browseFiles": "Sfoglia i file",
  "loadingDocuments": "Caricamento documenti...",
  "refresh": "Aggiorna",
  "download": "Scarica",
  "uploading": "Caricamento",
  "failed": "Non riuscito",
  "complete": "Completo",
  "noDocumentsAttachedYet": "Non ci sono ancora documenti allegati.",
  "documentPreview": "Anteprima del documento",
  "previewNotAvailableDownloadToViewThisFile": "Anteprima non disponibile — scaricare per visualizzare questo file.",
  "budgetLineDocuments": "Documenti di linea di bilancio",
  "attachSupportingDocumentsForThisBudgetLine": "Attacca documenti di supporto per questa linea di bilancio.",
  "openNamed": "Aperto {name}",
  "deleteNamed": "Eliminare “ {name} ”? Questo non può essere annullato.",
  "valuesCurrency": "Tutti i valori in {currency} ({symbol} )",
  "updatedAt": "Aggiornato {date}",
  "createdAt": "Creato {date}",
  "versionNumber": "Versione v {number}",
  "reforecastVersion": "Reforecast (v {number} )",
  "statusSet": "Stato di bilancio fissato a {status} .",
  "ownerName": "Proprietario: {name}",
  "departmentDefault": " (dept default)",
  "autoSaveState": "Risparmio automatico: {state}",
  "on": "Su",
  "off": "Fuori!",
  "submitting": "Inserire...",
  "withdrawing": "Ritiro...",
  "searching": "Ricerca…",
  "documentCountOne": "{count} documento",
  "documentCountMany": "{count} documenti",
  "uploadedAt": "Caricato {date}",
  "noResults": "Nessuna linea di bilancio corrisponde ai tuoi filtri.",
  "pending_open": "Inviato (Pending GM Open)",
  "votingOpen": "Votazioni aperte",
  "votingClosed": "Votazioni Chiuso",
  "withdrawn": "Ritiro",
  "close": "Chiudi",
  "errors": {
    "permissionDenied": "Non hai il permesso di eseguire questa azione. Contatta l'amministratore del club.",
    "invalidFields": "Controlla il nome, le date fiscali e il budget/versione selezionato, quindi riprova.",
    "budgetMissing": "Questo bilancio non è più disponibile. Ritorno alla lista di bilancio.",
    "versionMissing": "Questa versione non è più disponibile. Aggiorna e seleziona un'altra versione.",
    "lineMissing": "Questa linea non è più disponibile. Rifiuta il budget.",
    "versionReadOnly": "Questa versione è in sola lettura. Creare una nuova versione di bozza per apportare modifiche.",
    "invalidTransition": "Questo cambiamento di stato non è consentito. Rifiutare di controllare lo stato corrente.",
    "deleteRestricted": "Solo i progetti di bilancio senza versioni bloccate possono essere eliminati.",
    "duplicateLine": "Una linea di bilancio con questi dettagli esiste già. Modifica la linea esistente.",
    "fileTooLarge": "Scegliere un file non più grande di 25 MB.",
    "fileType": "Scegli un documento supportato PDF , immagine o Word.",
    "fileSizeMismatch": "La dimensione del file caricato non corrispondeva. Prova a caricare di nuovo il file.",
    "attachmentMissing": "Questo documento non è più disponibile. Aggiorna l'elenco dei documenti.",
    "withdrawRestricted": "Questa sottomissione può essere ritirata solo prima dell'apertura del voto.",
    "votesExist": "I voti esistono già per questa mozione.",
    "notSubmitted": "Questa versione di bilancio non è attualmente presentata.",
    "motionMissing": "Non è stata trovata alcuna mozione in sospeso per questa presentazione."
  },
  "deleteBudgetConfirm": "Eliminare il budget?"
};
